module.exports = __webpack_public_path__ + "img/miOsfatun.124e0833.svg";